module.exports = __webpack_public_path__ + "img/float-btn-cockfigh.3d1ba423.svg";